import React from 'react';

import { AddToCartFormHelper } from './form/AddToCartForm';
import { Div } from './HTMLElement';
import { RecommendedCartProductTileProps } from './RecommendedCartProductTile';
import { RecommendedCartProductTileBasicInfo } from './RecommendedCartProductTileBasicInfo';
import { RecommendedCartProductTileExtraInfo } from './RecommendedCartProductTileExtraInfo';

export const RecommendedCartProductTileA = ({ product }: RecommendedCartProductTileProps) => {
  const [showMore, setShowMore] = React.useState(false);

  const handleToggleShowMoreClick = React.useCallback(() => {
    setShowMore((prevState) => !prevState);
  }, []);

  return (
    <Div className="recommended-cart-product-tile">
      <AddToCartFormHelper product={product} scope="tile">
        {({ fieldsHelper, priceHelper, selectedProductVariant, selectedSku }) => (
          <React.Fragment>
            <RecommendedCartProductTileBasicInfo
              fieldsHelper={fieldsHelper}
              onToggleShowMore={handleToggleShowMoreClick}
              priceHelper={priceHelper}
              product={selectedProductVariant}
              showMore={showMore}
              sku={selectedSku}
            />
            {showMore && (
              <RecommendedCartProductTileExtraInfo
                fieldsHelper={fieldsHelper}
                onToggleShowMore={handleToggleShowMoreClick}
                priceHelper={priceHelper}
                product={selectedProductVariant}
                showMore={showMore}
                sku={selectedSku}
              />
            )}
          </React.Fragment>
        )}
      </AddToCartFormHelper>
    </Div>
  );
};
